import React, { Component } from "react";
import styled from "styled-components";

import MaterialIconButton from "@material-ui/core/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row, Text } from "../../comps";
import { Theme } from "../../theme/theme-provider";

import { faKeyboard } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
`;

const Head = styled(Row)`
  width: 90%;
  margin-top: 12px;
  margin-bottom: 8px;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.GRAY_1};
`;

const KeyControl = ({ name, func }) => {
  return (
    <Row
      alignItems="center"
      style={{
        marginTop: "6px",
        marginBottom: "6px",
        justifyContent: "space-between",
      }}
    >
      <Text
        style={{
          border: `1px solid ${Theme.color.GRAY_1}`,
          borderRadius: "3px",
        }}
        width="28%"
        fontSize="14px"
        fontWeight={500}
        textAlign="center"
        color={Theme.color.GRAY_0}
      >
        {name}
      </Text>
      <Text
        width="60%"
        fontSize="16px"
        fontWeight={600}
        color={Theme.color.GRAY_0}
      >
        {func}
      </Text>
    </Row>
  );
};

export default () => {
  return (
    <Wrapper>
      <Head>
        <MaterialIconButton size="large">
          <FontAwesomeIcon
            style={{ fontSize: "24px", color: Theme.color.GRAY_1 }}
            icon={faKeyboard}
          />
        </MaterialIconButton>
        <Text
          fontSize="24px"
          fontWeight={600}
          marginLeft="10px"
          color={Theme.color.GRAY_1}
        >{`Keyboard Controls`}</Text>
      </Head>
      <KeyControl name="Ctrl + R" func="Go to synced Room" />
      <KeyControl name="Ctrl + M" func="Toggle Mini Mode" />
      <KeyControl name="Ctrl + F" func="Toggle Full Screen" />
      <KeyControl name="Ctrl + E" func="Expand/Collapse Player" />
      <KeyControl name="Ctrl + P" func="Play/pause" />
      <KeyControl name="Ctrl + →" func="Next" />
      <KeyControl name="Ctrl + ←" func="Previous" />
    </Wrapper>
  );
};
